import { i as o } from "./lit-element-8JrrHldg.js";
var e = o`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;
export {
  e as c
};
